import { polyfill, trustPolicies } from "https://cdn.kernvalley.us/js/std-js/TrustedTypes.js";
const polyfilled = polyfill();
export { trustPolicies, polyfilled };